import user from './user'
import review from './review'
import reports from './reports'
import forecasts from './forecasts'
import newsletters from './newsletters'
import auth from './auth'
import newsletter from './newsletter'
import recipients from './recipients'

const api = (axios) => ({
  axios,
  user: user(axios),
  review: review(axios),
  reports: reports(axios),
  forecasts: forecasts(axios),
  newsletters: newsletters(axios),
  auth: auth(axios),
  newsletter: newsletter(axios),
  recipients: recipients(axios),
})

export default api
